const yellow = {
  300: "#f5ca58",
  500: "rgb(213, 171, 59)",
  700: "#aa882f",
};

export default yellow;
